import React, {
  useRef,
  useState,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import "../../styles/KeyFeatures.css";
import EngagementIcon from "../../assets/Engagement.png";
import beemz_socialsIcon from "../../assets/beemz_socials.png";
import Continous_OrderingIcon from "../../assets/Continous_Ordering.png";
import online_presenceIcon from "../../assets/online_presence.png";
import multi_platformIcon from "../../assets/multi_platform.png";
import ai_powerdIcon from "../../assets/ai_powerd.png";
import rightuparrow from "../../assets/right-up-arrow.png";
import FancyGetStartedButton from "./FancyGetStartedButton";
import GlowButton from "./GlowButton";


function IconRenderer({ icon }) {
  if (!icon) return null;
  if (typeof icon === "string")
    return <img src={icon} alt="" className="kf-icon-img" />;
  return icon;
}

/** Final 6 feature cards */
const DEFAULT_FEATURES = [
  {
    title: "real-time customer engagement",
    body:
      "enable instant chat-driven communication between customers and staff, eliminating wait times and boosting satisfaction through ai-assisted support",
    more:
      "two-way messaging, alerts, and smart replies reduce response time and increase conversions.",
    icon: EngagementIcon,
    color: "var(--card-1)"
  },
  {
    title: "ai-powered ordering system",
    body:
      "beɘmz ai manages customer orders and queries taking into account their preferences and allergies remembering customer favorites creating hyper personalised recommendations giving your customers vip treatment every time",
    more:
      "dynamic flows, upsell suggestions, and allergy-aware options built-in.",
    icon: ai_powerdIcon,
    color: "var(--card-2)",
  },
  {
    title: "continuous ordering and payments",
    body:
      "our in-chat ordering system enables your customers to order and pay anytime, accommodating individuals and large group orders.our unique order flow keeps everyone informed based on item, order and payment status. these can be customised.",
    more:
      "reduce customer waiting anxiety through instant chat-driven messaging between customer and staff, eliminating wait times and boosting satisfaction through ai-assisted support. all location-based. simultaneously support all your locations, never miss a customer query or order, be it 1 or 1 million.",
    icon: Continous_OrderingIcon, // your icon path here
    color: "var(--card-3)",
  },
  {
    title: "multi-platform accessibility",
    body:
      "accessible anywhere, seamlessly serve customers on ios, android, web and mobile web with one unified platform. no matter how many locations you have, all are managed and visible through one account, mobile vendors or brick and mortar alike",
    more:
      "role-based access, SSO, branches/teams, and centralized analytics.",
    icon: multi_platformIcon,
    color: "var(--card-4)",
  },
  {
    title: "beɘmz socials and fast marketing",
    body:
      "use beɘmz rich location based social media features to acquire new customers and deepen your connection with existing customers. be visible and post content locally. all users can like, follow and share. use ‘fast marketing’ to maximise your marketing spend through real time,",
    more:
      "geo targeted ads. low cost ads giving you the freedom to advertise when, where and how ever long you like",
    icon: beemz_socialsIcon,
    color: "var(--card-1)",
  },
  {
    title: "on-line presence",
    body:
      "your beɘmz business profile gives you the ability to publish content, menu's, catalogs and even items, easily per location. show team members, operating times and even create events independently for each of your locations. customer interaction and ordering can be triggered from each location or any team members profile",
    more:
      "keep profiles unified yet flexible across outlets; perfect for franchises.",
    icon: online_presenceIcon,
    color: "var(--card-2)",
  },
];

export default function KeyFeature({
  heading = "key features that",
  accent = "power your growth",
  subtext = "from seamless operations to smarter customer engagement, every feature is built to boost efficiency, delight customers, and maximize revenue. zero commission model, your revenue is yours keep your profit in your pocket.",
  features = DEFAULT_FEATURES,
  cardWidth = 329, // Show 4 complete cards initially
  gap = 15,
}) {
  const scrollerRef = useRef(null);
  const [active, setActive] = useState(0);
  const [expandedCards, setExpandedCards] = useState(new Set());
  const [selectedCard, setSelectedCard] = useState(0); // Track selected card
  const [showMoreSectionForCOrder, setShowMoreSectionForCOrder] = useState(false);
  const [showLessSectionForCOrder, setShowLessSectionForCOrder] = useState(true);
  const [showMoreSectionForMarketing, setShowMoreSectionForMarketing] = useState(false);
  const [showLessSectionForMarketing, setShowLessSectionForMarketing] = useState(true);
  const [showArrow, setShowArrow] = useState(true);
  const [fontSize, setFontSize] = useState(17); // initial font size (in px)
  const [isMouseOver, setIsMouseOver] = useState(false);

  const itemStyle = useMemo(
    () => ({ minWidth: `${cardWidth}px`, scrollSnapAlign: "start" }),
    [cardWidth]
  );

  const onScroll = useCallback(() => {
    const el = scrollerRef.current;
    if (!el) return;
    const idx = Math.round(el.scrollLeft / (cardWidth + gap));
    setActive(Math.max(0, Math.min(idx, features.length - 1)));
  }, [features.length, cardWidth, gap]);

  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [onScroll]);

  const scrollByCards = (count) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollBy({ left: count * (cardWidth + gap), behavior: "smooth" });
  };

  const toggleCard = (i) =>
    setExpandedCards((prev) => {
      const next = new Set(prev);
      next.has(i) ? next.delete(i) : next.add(i);
      return next;
    });

  const handleMouseOver = (i) => {
    setSelectedCard(i); // Set the clicked card as selected
    setShowArrow(false);
  };

  const changeSeeMoreToFullContent = (i) => {
    if (i === 2) {
      setShowMoreSectionForCOrder(true);
      setShowLessSectionForCOrder(false);
    }
    else if (i === 4) {
      setShowMoreSectionForMarketing(true);
      setShowLessSectionForMarketing(false);
    }
  }

  const changeSeeLessToFullContent = (i) => {
    if (i === 2) {
      setShowMoreSectionForCOrder(false);
      setShowLessSectionForCOrder(true);
      // setFontSize(17);
    }
    else if (i === 4) {
      setShowMoreSectionForMarketing(false);
      setShowLessSectionForMarketing(true);
    }
  }

  return (
    <section className="kf-wrap">
      <div className="kf-bg" aria-hidden="true" />
      <div className="kf-container">
        <h2 className="kf-title">
          {heading}
        </h2>
        {/* Accent text should be below the title */}
        <p className="kf-accent">
          {accent}
        </p>

        <p className="kf-sub">{subtext}</p>

        {/* scroller */}
        <div ref={scrollerRef} className="kf-scroller" style={{ gap }}>
          {features.map((f, i) => {
            const expanded = expandedCards.has(i);
            const isSelected = selectedCard === i; // Check if the card is selected
            return (
              <article
                key={i}
                className={`kf-card ${isSelected ? "selected" : ""}`} // Apply "selected" class if active
                style={{ ...itemStyle, background: 'f.color' }}
                onMouseOver={() => handleMouseOver(i)} // Handle card click
              >
                <div className="kf-card-icon"><IconRenderer icon={f.icon} /></div>
                <h3 className="kf-card-title">{f.title}</h3>
                <p className={`kf-card-body ${expanded ? "expanded" : "clamped"}`} >

                  {/* made font size less for card 3 */}
                  {(i == 2 && !showMoreSectionForCOrder) && <span id={i} style={{ fontSize: `${fontSize}px` }}>{expanded ? `${f.body} ${f.more}` : f.body} </span>}
                  {(i == 4 && !showMoreSectionForMarketing) && <span id={i} style={{ fontSize: `${fontSize}px` }}>{expanded ? `${f.body} ${f.more}` : f.body} </span>}
                  {/* nothing changes in font size for other than card 3 */}
                  {(i != 2 && i != 4) && <span>{expanded ? `${f.body} ${f.more}` : f.body} </span>}

                  {(i == 2) && <span onClick={() => changeSeeMoreToFullContent(i)}>{" "} {showLessSectionForCOrder && <button className="mt-1 text-[#FCBA05] cursor-pointer">see more... </button>}
                    {i == 2 &&
                      <span> {showMoreSectionForCOrder && <span className="block max-h-[260px] overflow-y-auto scrollbar-hide mb-[5px]" style={{ fontSize: `${fontSize}px` }}> our in-channel ordering system enables customers to order and pay anytime, accommodating individuals and large group orders.
                        our unique order flow keeps everyone informed based on item, order and payment status. these can be customised. reduce customer waiting anxiety through instant chat-driven messaging between customer and staff,
                        eliminating wait times and boosting satisfaction through  ai assisted support. all location based.
                        simultaneously support all your locations, never miss a customer query or order, be it 1 or 1 million </span>}</span>} </span>}
                  {i == 4 &&
                    <span> {showMoreSectionForMarketing && <span className="block max-h-[260px] overflow-y-auto scrollbar-hide mb-[5px]" style={{ fontSize: `${fontSize}px` }}> use beɘmz rich location based social media features to acquire new customers and deepen your connection with existing customers.
                      be visible and post content locally. all users can like, follow and share. use ‘fast marketing’ to maximise your marketing spend through real time,geo targeted ads. low cost ads giving you the freedom to advertise when, where and how ever long you like
                    </span>}</span>}

                  {(i == 4) && <span onClick={() => changeSeeMoreToFullContent(i)}>{" "}{showLessSectionForMarketing && <button className="mt-1 text-[#FCBA05] cursor-pointer">see more...</button>}
                    {/* {i == 4 &&
                      <span> {showMoreSectionForMarketing && <span className="block max-h-[200px] overflow-y-auto scrollbar-hide" style={{ fontSize: `${fontSize}px` }}>geo targeted ads. low cost ads giving you the freedom to advertise when, where and how ever long you like 
                      </span>}
                      </span>} */}
                  </span>}


                  {(i == 2 && showMoreSectionForCOrder) && <button className="mt-1 xl-2xl:mt-[-2rem] text-[#FCBA05] cursor-pointer" onClick={() => changeSeeLessToFullContent(i)} >see less...</button>}
                  {(i == 4 && showMoreSectionForMarketing) && <button className="mt-1 xl-2xl:mt-[-1rem] text-[#FCBA05] cursor-pointer" onClick={() => changeSeeLessToFullContent(i)} >see less...</button>}

                </p>

                {/* For "Get Started" button >*/}
                {(i === 2 && showMoreSectionForCOrder) ?
                  <div className="kf-get-started ml-8 mt-[-10rem]">
                    {isSelected &&
                      // Centered for the first card
                      // <a href="https://indosakura.com/" className="kf-get-started-link" >
                      //   <span>get started</span>
                      //   <span className="kf-get-started-icon">↗</span>
                      // </a>
                      <span className="ml-[-1.5rem]">
                        <FancyGetStartedButton onMouseOver={() => setIsMouseOver(true)} onMouseOut={() => setIsMouseOver(false)} isMouseOver={isMouseOver} />
                      </span>

                    }
                  </div> :
                  i === 0 || i === 5 ?
                    <div className="kf-get-started">
                      {isSelected &&
                        // Centered for the first card
                        // <a href="https://indosakura.com/" className="kf-get-started-link" >
                        //   <span>get started</span>
                        //   <span className="kf-get-started-icon">↗</span>
                        // </a>
                        // <span className=" ml-[9px] ml-[-2rem]">
                        //   <FancyGetStartedButton onMouseOver={() => setIsMouseOver(true)} onMouseOut={() => setIsMouseOver(false)} isMouseOver={isMouseOver} />
                        // </span>

                        <div className="mt-4 flex justify-center items-center gap-2">
                            <button
                              onClick={() => window.location.href = "/business/demo"}
                              className="h-[48px] inline-flex items-center justify-center whitespace-nowrap border border-[#6E3FC6] bg-[#e9d9ff] hover:bg-[#d8bfff] text-black text-sm sm:text-base font-medium px-[14px] rounded-full transition-all duration-300 cursor-pointer"
                            >
                              how it works
                            </button>
                            <span><GlowButton btnValue="free trial" btn1="2" onClick={() => window.location.href = "/business/get-started"}></GlowButton></span>
                          </div>

                      }
                    </div> :
                    (i === 4 && showMoreSectionForMarketing) ?
                      <div className=" mt-[-9rem]">
                        {isSelected &&
                          // Centered for the first card
                          // <a href="https://indosakura.com/" className="kf-get-started-link" >
                          //   <span>get started</span>
                          //   <span className="kf-get-started-icon">↗</span>
                          // </a>
                          // <span className="ml-[9px]">
                          //   <FancyGetStartedButton onMouseOver={() => setIsMouseOver(true)} onMouseOut={() => setIsMouseOver(false)} isMouseOver={isMouseOver} />
                          // </span>
                          <div className="mt-4 flex justify-center items-center gap-2">
                            <button
                              onClick={() => window.location.href = "/business/demo"}
                              className="h-[48px] inline-flex items-center justify-center whitespace-nowrap border border-[#6E3FC6] bg-[#e9d9ff] hover:bg-[#d8bfff] text-black text-sm sm:text-base font-medium px-[14px] rounded-full transition-all duration-300 cursor-pointer"
                            >
                              how it works
                            </button>
                            <span><GlowButton btnValue="free trial" btn1="2" onClick={() => window.location.href = "/business/get-started"}></GlowButton></span>
                          </div>

                        }
                      </div> :
                      <div className="kf-get-started">
                        {isSelected &&
                          // Centered for the first card
                          // <a href="https://indosakura.com/" className="kf-get-started-link" >
                          //   <span>get started</span>
                          //   <span className="kf-get-started-icon">↗</span>
                          // </a>
                          // <span className="ml-[9px]">
                          //   <FancyGetStartedButton onMouseOver={() => setIsMouseOver(true)} onMouseOut={() => setIsMouseOver(false)} isMouseOver={isMouseOver} />
                          // </span>
                          <div className="mt-0 flex justify-center items-center gap-2">
                            <button
                              onClick={() => window.location.href = "/business/demo"}
                              className="h-[48px] inline-flex items-center justify-center whitespace-nowrap border border-[#6E3FC6] bg-[#e9d9ff] hover:bg-[#d8bfff] text-black text-sm sm:text-base font-medium px-[14px] rounded-full transition-all duration-300 cursor-pointer"
                            >
                              how it works
                            </button>
                            <span><GlowButton btnValue="free trial" btn1="2" onClick={() => window.location.href = "/business/get-started"}></GlowButton></span>
                          </div>

                        }
                      </div>
                }

                {/* For "Arrow symbol */}
                <div className="kf-get-started">
                  {!isSelected &&
                    // Centered for the first card
                    <div className="kf-card-actions">

                      <span className="block text-right tracking-wide leading-tight"></span>
                      <img
                        src={rightuparrow}
                        alt="Get it on Google Play"
                        className="h-10 sm:h-10 md:h-8 cursor-pointer hover:scale-105 transition-transform duration-300"
                      />
                    </div>

                  }
                </div>
              </article>
            );
          })}
        </div>

        {/* pager */}
        <div className="kf-pager">
          {features.map((_, i) => (
            <button
              key={i}
              className={`kf-dot ${active === i ? "is-active" : ""}`}
              onMouseOver={() => {
                const el = scrollerRef.current;
                if (!el) return;
                el.scrollTo({ left: i * (cardWidth + gap), behavior: "smooth" });
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
